/**
 * 接口文档
 * https://www.tapd.cn/45874634/personal_documents/view/1145874634001000151
 */

import request from '@/utils/request'
import { getRequest, delUrlParam } from '@/utils'
import { getCode } from '@/utils/third-insert'

const COMPANY_UID_MAP = 'company_uid_map'
/**
 * 校验 uid
 */
function validUid (uid) {
    return (typeof uid === 'string' && uid.length === 22)
}

/**
 *
 */
function getCompanyUidMap () {
    let companyUidMap = {}

    try {
        /**
         * localStorage.getItem() 无 key 时，return null
         * JSON.parse(null) return null
         */
        companyUidMap = JSON.parse(localStorage.getItem(COMPANY_UID_MAP))
            || {}
    } catch {
        companyUidMap = {}
    }

    return companyUidMap
}

/**
 * 获取 chat_user_id
 * @param { String } companyCode
 */
export function getUid (companyCode) {
    let companyUidMap = getCompanyUidMap(companyCode)
    let uid = companyUidMap[companyCode]
    const client = getRequest().client
    if (!validUid(uid)) {
        uid = ''
    }
    //if (!uid || client) {
    let params = { 
        e: getRequest().e,
        chat_user_id: uid
    }

    if (['wxwork_h5', 'dingding_h5'].includes(client) && !getRequest().code) {
        getCode(client)
        return
    }
    
    switch (client) {
        case 'wxwork_h5':
        case 'dingding_h5':
            params = {
                ...params,
                client,
                code: getRequest().code,
                chat_user_id: uid        
            }
            break
        case 'wxapp_h5':
            params = {
                ...params,
                client,
                openid: getRequest().openid,
                name: getRequest().name,
                avatar: getRequest().avatar,
                mobile: getRequest().phone,
                email: getRequest().email,
                chat_user_id: uid
            }
            break
        default:
            break
    }

    if ( getRequest().code ) {
        let url = delUrlParam(location.href, ['code'])
        history.replaceState({url:url}, '', url)
    }
    //}
   
    return request({
        url: 'chat/user/id',
        method: 'get',
        params
    })
    // uid = response.chat_user_id
    //}
    //return uid
}

/**
 * centrifuge 的 token 失效后需要请求新 token
 * @param { String } entryKey
 * @param { String } uid
 */
export function postSocketRefresh (entryKey, uid) {
    return request({
        url: 'centrifugo/refresh',
        method: 'post',
        data: {
            e: entryKey,
            chat_user_id: uid
        }
    })
}

/**
 * 获取 socket 的配置信息
 * @param { String } entryKey
 * @param { String } uid
 */
export function getSocketConfig (entryKey, uid) {
    return request({
        url: 'centrifugo/chat_user/token',
        method: 'get',
        params: {
            e: entryKey,
            chat_user_id: uid
        }
    })
}

/**
 * 发送消息
 * @param { Object } data
 * @param { String } data.e
 * @param { String } data.chat_user_id
 * @param { String } data.source
 * @param { Object } data.message
 */
export function postMessage (data) {
    data.robot_key = getRequest().robot_key || ''
    return request({
        url: 'chat',
        method: 'post',
        data
    })
}

/**
 * 获取历史记录
 * @param { Object } data
 * @param { String } data.uid
 * @param { Number } [data.startTime]
 * @param { Number } [data.endTime]
 * @param { Number } [data.pageNum]
 * @param { Number } [data.pageSize=12]
 */
export function getMessageHistory ({
    uid,
    startTime,
    endTime,
    pageNum,
    pageSize
}) {
    return request({
        url: 'chat/log',
        method: 'get',
        params: {
            chat_user_id: uid,
            start_time: startTime,
            end_time: endTime,
            page: pageNum,
            per_page: pageSize
        }
    })
}

/**
 * 获取欢迎语等配置信息
 * @param { String } entryKey
 * @param { String } uid
 */
export function getGuideAndOtherConfig (entryKey, uid) {
    return request({
        url: 'guide',
        method: 'get',
        params: {
            chat_user_id: uid,
            e: entryKey
        }
    })
}

/**
 * 表示用户目前处于机器人 or 人工状态，、
 * 返回 机器人会话 robot、人工会话状态 human、排队状态 queue
 * @param { String } uid
 */
export function getServiceStatus (uid) {
    return request({
        url: `chat/user/${uid}/status`,
        method: 'get',
        params: {
            e: getRequest().e
        }
    })
}

/**
 * 消息已阅读
 * @param { String[] } idFromServers
 */
export function postMessageRead (idFromServers) {
    return request({
        url: 'chat/log/readed',
        method: 'post',
        data: {
            msg_ids: idFromServers
        }
    })
}

/**
 * 消息重发
 * 造成消息发送失败的情况有两种：
 *  1. 发送消息失败（ajax），此时 idFromServer 为空
 *  2. webscoket 返回错误信息（实际成功/失败都有可能）
 *
 * @param { Object } data
 * @param { String } [data.msg_id]
 * @param { String } data.chat_user_id
 * @param { String } data.e
 * @param { String } data.source
 * @param { Object } data.message
 * @param { String } data.message.type
 * @param { String } data.message.detail_type
 * @param { Object | String } data.message.data
 */
export function postMessageResend (data) {
    return request({
        url: 'chat/log/resend',
        method: 'post',
        data
    })
}

/**
 * 根据输入文本查找相关问题
 * @param { String } entryKey
 * @param { String } question
 */
export function getRelatedQuestion (uid, source, entryKey, question) {
    return request({
        url: 'robot/search/question',
        method: 'get',
        params: {
            chat_user_id: uid,
            source,
            e: entryKey,
            question,
            robot_key:getRequest().robot_key || ''
        }
    })
}

/**
 * 正在输入
 * @param { bool } isinput
 * @param { String } chat_user_id
 */
export function istheinput (uid, isinput, content) {
    return request({
        url: 'chat/user/input/status',
        method: 'post',
        data: {
            chat_user_id: uid,
            is_input:isinput,
            content
        }
    })
}

/**
 * 以上都不是，适用于 option（即 recomend）消息类型
 * @param { String } uid
 * @param { String } source
 * @param { String } entryKey
 * @param { String } idFromServer
 */
export function putAllNot (uid, source, entryKey, idFromServer) {
    return request({
        url: 'robot/callback/question_all_not',
        method: 'put',
        data: {
            chat_user_id: uid,
            source,
            e: entryKey,
            msg_id: idFromServer,
            robot_key:getRequest().robot_key || ''
        }
    })
}

/**
 * 退出排队
 * @param { String } uid
 */
export function putNoQueue (uid) {
    return request({
        url: 'chat/queue/exit',
        method: 'put',
        data: {
            chat_user_id: uid
        }
    })
}

/**
 * 获取客服用户字段信息
 * @param { String } uid - 客服的 id
 */
export function getServiceUserInfo (uid) {
    return request({
        url: `chat/customer_service/${uid}`,
        method: 'get'
    })
}

/**
 * 对机器人回复的消息进行评价
 * @param { String } uid
 * @param { String } entryKey
 * @param { String } source
 * @param { String } idFromServer
 * @param { Boolean } isSolved
 */
export function postEvaluateMessage (
    uid,
    entryKey,
    source,
    idFromServer,
    isSolved
) {
    return request({
        url: 'robot/callback/question_solve',
        method: 'put',
        data: {
            msg_id: idFromServer,
            chat_user_id: uid,
            e: entryKey,
            source,
            is_solved: isSolved,
            robot_key:getRequest().robot_key || ''
        }
    })
}

/**
 * 链接上的参数
 */
export function postRquestParams (uid, paramsObj) {
    const newParamsObj = {}
    for (let i in paramsObj) {
        // eslint-disable-next-line no-empty
        if (i == 'e' || i == 'c' || i == 'hp') {} else {
            newParamsObj[i] = paramsObj[i]
        }
    }
    return request({
        url: `chat/${uid}/ext_info`,
        method: 'post',
        data: newParamsObj
    })
}
/**
 * 结束会话
 * @param { String } uid
 */
export function closeSession (uid) {
    return request({
        url: `/chat/${uid}/close/session`,
        method: 'post'
    })
}

/**
 * 获取当前接待人工客服信息
 * @param { String } uid
 */
export function getUserInfo (uid) {
    return request({
        url: `/chat/${uid}/user/info`,
        method: 'get'
    })
}
